import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { useEffect } from "react";
import { useState } from "react";
import Modal from "react-responsive-modal";
import GeneralService from "services/GeneralService";
import { useTeamContext } from "store/contexts/teamContext";

const MediaSummary = ({ handleModal, formik, afterTranscribe }) => {
  const { team } = useTeamContext();

  const [step, setStep] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    (async () => {
      const { values } = formik;
      if (values.attachment) {
        setStep(1);
        const preSignedResponse = await GeneralService.getPresignedUploadURL({
          filename: values.attachment.name,
          mime_type: values.attachment.type,
          file_size: values.attachment.size,
          resource_type: "team",
          resource_id: team.id,
          resource_policy: "team.celebration",
        });

        const { key, url } = preSignedResponse.data.data;

        await GeneralService.uploadToS3(url, values.attachment, (progress) => {
          setProgress(`${Math.floor(progress)}%`);
        });

        setStep(2);
        const transciption = await GeneralService.transcribeVideo({
          team_id: team.id,
          media: key,
        });
        afterTranscribe(transciption.data.data.content);
        handleModal();
      }
    })();
  }, [formik, team.id, afterTranscribe, handleModal]);

  return (
    <Modal
      open
      onClose={handleModal}
      showCloseIcon={false}
      classNames={{
        modalContainer: "modalContainer",
        modal: "queryModalContainer",
      }}
    >
      <div className="confirmationModalContent">
        <div className="chatGptQueryHeader">
          <h5 className="text-center confirmationModalHeader">Summarizer</h5>
          <span className="chatgptCloseModal">
            <CancelIcon className="closeIcon" onClick={handleModal} />
          </span>
        </div>
        <hr />
        <div>
          {step === 1 && (
            <div className="action-items-container align-items-center d-flex justify-content-center flex-col gap-2">
              <h4>Media uploaded {progress}</h4>
            </div>
          )}
          {step === 2 && (
            <div className="action-items-container align-items-center d-flex justify-content-center flex-col gap-2">
              <h4>Transcribing video...</h4>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default MediaSummary;
